import i18n from 'i18next';
// import LocizeBackend from 'i18next-locize-backend';
// import LocizeEditor from 'locize-editor';
import LanguageDetector from 'i18next-browser-languagedetector';
import {reactI18nextModule} from 'react-i18next';
import XHR from "i18next-xhr-backend";
import {config} from "./services/Config";

const instance = i18n
    .use(LanguageDetector)
    .use(reactI18nextModule)
    .use(XHR)
    .init({
        fallbackLng: 'en',
        appendNamespaceToCIMode: true,
        // saveMissing: true,
        saveMissing: false,

        // have a common namespace used around the full app
        ns: ['GLOBAL'],
        defaultNS: 'GLOBAL',
        fallbackNS: 'GLOBAL',

        debug: false,
        keySeparator: '### not used ###', // we use content as keys

        interpolation:
        {
            escapeValue: false, // not needed for react!!
            formatSeparator: ',',
            format: function (value: string, format: string, lng: string) {
                if (format === 'uppercase') {
                    return value.toUpperCase();
                }
                return value;
            }
        },

        react:
        {
            wait: true
        },
        backend:
        {
            loadPath: config.baseURL + "/labels?languageCode={{lng}}&namespace={{ns}}",
            allowMultiLoading: false,
            // addPath: "..."
        },

    });

export default instance;



// WEBPACK FOOTER //
// ./src/i18n.tsx